/**
 * Event Types
 *
 * Type definitions for event notifications and banners.
 * Designed to be database-ready for future integration.
 */

export enum EventType {
  ANNOUNCEMENT = "ANNOUNCEMENT",
  MEMORIAL = "MEMORIAL",
  CELEBRATION = "CELEBRATION",
  TRAINING = "TRAINING",
  MEETING = "MEETING",
  ALERT = "ALERT",
}

export enum EventPriority {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  URGENT = "URGENT",
}

export interface Event {
  id: string;
  title: string;
  description: string;
  type: EventType;
  priority: EventPriority;
  startDate: Date;
  endDate: Date;
  bannerImageUrl?: string;
  detailsImageUrl?: string;
  showBanner: boolean;
  showModal: boolean;
  dismissible: boolean;
  actionUrl?: string;
  actionLabel?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface EventNotificationState {
  eventId: string;
  dismissed: boolean;
  modalShown: boolean;
  dismissedAt?: Date;
  lastShownAt?: Date;
}
